import { Button, Result } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import type { NormalizedError } from '@/api/errors';
import { useI18n } from '@/i18n/useI18n';
import { errorCopyBase } from '@/lib/errorCopy';

/** A calm, retryable error block for a failed page load (tasks/status). Never shows a raw error. */
export function PageError({ error, onRetry }: { error: NormalizedError | null; onRetry: () => void }) {
  const { t } = useI18n();
  const base = errorCopyBase(error?.kind ?? 'UNKNOWN');
  return (
    <Result
      status="warning"
      title={t(`${base}.title`)}
      subTitle={t(`${base}.body`)}
      extra={
        <Button type="primary" icon={<ReloadOutlined />} onClick={onRetry}>
          {t('common.retry')}
        </Button>
      }
    />
  );
}
